/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';

export function getCodeBlocks(feature: BaseNode): CodeBlock[] {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TABLE = project.getFeature(feature.getSettingValue('TABLE'));
    if (!TABLE) {
        return blocks;
    }
    const TABLE_NAME = TABLE.getSettingValue('NAME');
    const FIELDS = TABLE.getSettingValue('FIELDS');

    const doneLinks = project.getNodeLinks(feature, 'done');
    const doneBlock = doneLinks.length > 0 ? `'****${doneLinks[0].getSourceId()}****'` : '';
    const links = project.getNodeLinks(feature, 'tbl_add');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        let rowStr = '"\\x22"+';
        for (let i = 0; i < FIELDS.length; i += 1) {
            const field = FIELDS[i];
            const fieldDataType = field.getSettingValue('FIELDTYPE');
            const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
            const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
            const argExpression = project.getNodeParameterValue(feature, field.getSettingValue('NAME'));
            const input = project.parseCodeExpression(
                argExpression, sourceParams, TibboDataType.DWORD,
            );
            let inputDataType;
            const regex = /\{\{\$[a-z1-9]*\}\}/g;
            if (regex.test(argExpression)) {
                const id = argExpression.match(regex)[0].replace('{{$', '').replace('}}', '');
                const inputFeature = project.getFeature(id);
                if (inputFeature !== undefined) {
                    inputDataType = inputFeature.getSettingValue('DATATYPE');
                }
            }
            switch (fieldDataType) {
                case 'E': // Timestamp
                    rowStr += `lstr(${input})`;
                    break;
                case 'M': // Time in seconds
                    if (inputDataType === TibboDataType.TIME) {
                        rowStr += `fstr(${input})`;
                    } else {
                        rowStr += `lstr(datetime_timestamp_mins(${input}) * 60)`;
                    }
                    break;
                default:
                    rowStr += `${project.getNodeParameter(link, field.getSettingValue('NAME'))}`;
                    break;
            }

            if (i < FIELDS.length - 1) {
                rowStr += '+"\\x22,\\x22"+';
            }
        }
        rowStr += '+"\\x22"';
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
    tbl_delete_old_records("${TABLE_NAME}")
    tbl_web_add_row("${TABLE_NAME}",${rowStr})
    ${doneBlock}`,
        });
    }

    return blocks;
}
